import {closeSubMenus} from "./closeSubMenus";
import {closeAllSearch} from "./search";
const mediaLg = window.matchMedia("(min-width: 1024px)");
const mainNavigationItems = document.querySelectorAll(".header__bottom-navigation > ul > li");

if (mainNavigationItems.length > 0) {
  mainNavigationItems.forEach((li, i) => {
    const anchor = li.querySelector(':scope > a');
    anchor.addEventListener("click", (e) => onMobileNavItemClick(e, li));
    
    li.addEventListener('mouseenter', () => onDesktopNavItemMouseEnter(li, i));
    li.addEventListener('mouseleave', () => onDesktopNavItemMouseLeave(li, i));
  })
  
  document.addEventListener("keydown", event => {
    if (event.key === "Escape") {
      closeSubMenus();
    }
  })
}

function onMobileNavItemClick(e, li) {
  const isDesktop = mediaLg.matches;
  if (isDesktop) return;
  
  const hasSubMenu = li.classList.contains("has-submenu");
  const subMenuIsOpen = li.classList.contains("is-active");
  
  closeSubMenus();
  
  if (hasSubMenu) {
    e.preventDefault();
    
    if (!subMenuIsOpen) {
      openSubMenu(li);
    }
  }
}

function onDesktopNavItemMouseEnter (li) {
  const isMobile = !mediaLg.matches;
  if (isMobile) return;
  
  openSubMenu(li);
}

function onDesktopNavItemMouseLeave (li) {
  const isMobile = !mediaLg.matches;
  if (isMobile) return;
  
  li.classList.remove("is-active");
}

function openSubMenu (li) {
  li.classList.add("is-active");
  closeAllSearch();
}